import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Field, StyledInput } from 'pages/ManageClubEurostar/ManageClubEurostar.styles';
import Label from 'components/ui/Label';
import { isValidPassengersNumber } from 'utils/validators';
import { PAX_DESCRIPTIONS } from 'constants/booking';

import { AddCompanionsWrapper, StyledDescription } from './AddPassengersCta.styles';

const GeneralBookings = ({ register, errors }) => (
  <AddCompanionsWrapper>
    <Field>
      <Label htmlFor="adults">
        <FormattedMessage id="addPassengers.adults" />{' '}
        <StyledDescription>
          (<FormattedMessage id={`groupBooking.${PAX_DESCRIPTIONS.adults}`} />)
        </StyledDescription>
      </Label>
      <StyledInput
        {...register('adults', {
          validate: (value) => !value || isValidPassengersNumber(value)
        })}
        type="number"
        inputMode="numeric"
        id="adults"
        data-testid="adults"
        validationState={errors.adults ? 'error' : ''}
      />
    </Field>
    <Field>
      <Label htmlFor="children">
        <FormattedMessage id="addPassengers.children" />{' '}
        <StyledDescription>
          {' '}
          (<FormattedMessage id={`groupBooking.${PAX_DESCRIPTIONS.children}`} />)
        </StyledDescription>
      </Label>
      <StyledInput
        {...register('children', {
          validate: (value) => !value || isValidPassengersNumber(value)
        })}
        type="number"
        inputMode="numeric"
        id="children"
        data-testid="children"
        validationState={errors.children ? 'error' : ''}
      />
    </Field>

    <>
      <Field>
        <Label htmlFor="youths">
          <FormattedMessage id="addPassengers.youths" />{' '}
          <StyledDescription>
            {' '}
            (<FormattedMessage id={`groupBooking.${PAX_DESCRIPTIONS.youths}`} />)
          </StyledDescription>
        </Label>
        <StyledInput
          {...register('youths', {
            validate: (value) => !value || isValidPassengersNumber(value)
          })}
          type="number"
          inputMode="numeric"
          id="youths"
          data-testid="youths"
          validationState={errors.youths ? 'error' : ''}
        />
      </Field>
      <Field>
        <Label htmlFor="seniors">
          <FormattedMessage id="addPassengers.seniors" />{' '}
          <StyledDescription>
            {' '}
            (<FormattedMessage id={`groupBooking.${PAX_DESCRIPTIONS.seniors}`} />)
          </StyledDescription>
        </Label>
        <StyledInput
          {...register('seniors', {
            validate: (value) => !value || isValidPassengersNumber(value)
          })}
          type="number"
          inputMode="numeric"
          id="seniors"
          data-testid="seniors"
          validationState={errors.seniors ? 'error' : ''}
        />
      </Field>
    </>
  </AddCompanionsWrapper>
);

GeneralBookings.propTypes = {
  register: PropTypes.func,
  errors: PropTypes.shape({
    adults: PropTypes.string,
    children: PropTypes.string,
    youths: PropTypes.string,
    seniors: PropTypes.string
  })
};

export default GeneralBookings;
